import { DocumentOptionalFieldLink, OptionalFieldTypeTranslated } from '../../../types/Invoice';
import { TableColumn } from '../../table/DataTable.types';

export const columns = (
  handleEdit: (id: number, checked: boolean) => void,
  documentOptionalFields: DocumentOptionalFieldLink[],
) =>
  [
    {
      accessor: '',
      name: 'page.optional-field.col-show-on-document',
      cellRenderer: (e) => {
        const item = documentOptionalFields.find(
          (x: DocumentOptionalFieldLink) => x.optionalField.id === e.id,
        );
        return (
          <div>
            <input
              type={'checkbox'}
              checked={item !== undefined}
              onChange={(x) => handleEdit(item ? item?.id : e.id, x.target.checked)}
              className={`w-4 h-4 text-center mt-1`}
            />
          </div>
        );
      },
    },
    {
      accessor: 'value',
      name: 'page.optional-field.col-value',
    },
    {
      accessor: 'fieldType',
      name: 'page.optional-field.col-field-type',
      translateEnum: OptionalFieldTypeTranslated,
    },
  ] as TableColumn[];
